<template>
  <div class="life-submit flex_center">
    <div class="life-submit-btn" @click="lifeSubmit"
    :class="{ 'active-submit-btn': loading }">
      {{title}}
    </div>
  </div>
</template>

<script>
  import { throttle } from '@/util/util.js'

  export default {
    props: {
      title: {
        type: String,
        default: '确认支付'
      },
      loading: {
      		type: Boolean,
      		default: false
      },
      loadTitle: {
      		type: String,
      		default: '请求中'
      }
    },
    methods: {
      lifeSubmit: throttle(function() {
        if (this.loading) return
        this.$emit('submit')
      })
    }
  }
</script>

<style lang="less" scoped>
  .life-submit {
    width: 100%;
    height: 75px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999;
    padding: 10px;
    border-top: 0.5px solid #f2f2f2;
    margin: auto;
    max-width: 750px;

    .life-submit-btn {
      width: 100%;
      height: 61px;
      background: linear-gradient(180.00deg, #FFCA00, #FF6B00 100%);
      box-shadow: inset 0px -0.5px 0px #E2E3E4;
      border-radius: 6px;
      text-align: center;
      line-height: 61px;
      font-family: 思源黑体;
      font-size: 24px;
      color: #fff;
      font-weight: 700;
      letter-spacing: 0.6px;
    }
  }

  .active-submit-btn {
    background: #ccc !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/life-submit.vue